import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'

/**
 * PCS Details graph data
 * @param {string} stationCode
 * @param {number} blockIndex
 * @returns UseQueryResult
 */
const useEksPcsDetailsGraphQuery = (period) => {
  const { stationCode, blockIndex, eksPcsGroupId } = useParams()
  const { session } = useContext(SessionContext)
  return useQuery(
    ['eksPcsDetailsGraph', stationCode, blockIndex, eksPcsGroupId, period],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }

      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/pcsgroups/${eksPcsGroupId}/graph?period=${period}`,
        axiosOptions,
      )

      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useEksPcsDetailsGraphQuery
